import {
  FormObjType,
  FullRouteProps,
  HandleChangeType,
  HandleClickType,
  ParentRouteProps,
} from "DataTypes/Form";
import SwitchCase from "./SwitchCase";
import { RouteUrls } from "Constant/RouteUrls";
import { store } from "Redux/Store";
import { setNavArr } from "Redux/Screen/Action";
import { ReduxScreenNavType, ScreenInitialStateType } from "DataTypes/Redux";
import DateTime from "./DateTime";

const HandleValidateForm: (formData: FormObjType[]) => {
  formData: FormObjType[];
  errorCheck: boolean;
} = (formData) => {
  let singleEntryErrorCheck = false;
  const newArr = formData.map((el) => {
    let result = { error: false, errorText: "" };
    if (el.boxType == "input" && (el.required || el.inputVal)) {
      result = SwitchCase.InputValidation(el);
    }
    if (el.boxType == "single-select" && (el.required || el.dropVal)) {
      result = SingleValidation(el);
    }
    if (el.boxType == "multi-select" && (el.required || el.dropVal)) {
      result = MultiValidation(el);
    }
    if (
      (el.boxType == "date" || el.boxType == "date-time") &&
      (el.required || el.inputVal)
    ) {
      result = DateValidation(el);
    }
    if (result.error) singleEntryErrorCheck = true;
    el.errorText = result.errorText;
    el.error = result.error;
    return el;
  });
  return { formData: newArr, errorCheck: singleEntryErrorCheck };
};

const HandleInputChange: (
  data: HandleChangeType,
  formArr: FormObjType[]
) => FormObjType[] = ({ inputVal, id }, formArr) => {
  return formArr.map((formEl) => {
    if (formEl.id == id && formEl.boxType == "input") {
      formEl.inputVal = typeof inputVal == "string" ? inputVal : "";
      const temp = SwitchCase.InputValidation(formEl);
      formEl.error = temp.error;
      formEl.errorText = temp.errorText;
    }
    return formEl;
  });
};

const HandleInputChange2: (
  data: HandleChangeType,
  formArr: FormObjType[],
  formObj?: FormObjType
) => FormObjType[] = ({ inputVal, id }, formArr, formObj) => {
  const newInputVal = typeof inputVal == "string" ? inputVal : "";
  return formArr.map((formEl) => {
    if (formObj && formObj.boxType == "date" && formEl.boxType == "date") {
      if (formObj.dateType == "start" && formEl.dateType == "stop") {
        formEl.minVal = newInputVal || DateTime.CurrentDate()
      }
      if (formObj.dateType == "stop" && formEl.dateType == "start") {
        formEl.maxVal = newInputVal || DateTime.CurrentDate()
      }
    }
    if (formEl.id == id) {
      let newError = false;
      let newErrorText = "";
      formEl.inputVal = newInputVal;
      if (formEl.boxType == "input") {
        const temp = SwitchCase.InputValidation(formEl);
        newError = temp.error;
        newErrorText = temp.errorText;
      }
      if (formEl.boxType == "date") {
        const temp = DateValidation(formEl);
        newError = temp.error;
        newErrorText = temp.errorText;
      }
      formEl.error = newError;
      formEl.errorText = newErrorText;
    }
    return formEl;
  });
};

const HandleClickChange: (
  data: HandleClickType,
  formArr: FormObjType[]
) => FormObjType[] = ({ dropVal, id, boxType }, formArr) => {
  return formArr.map((formEl) => {
    if (
      formEl.id == id &&
      formEl.boxType == "single-select" &&
      boxType == "single-select" &&
      !Array.isArray(dropVal)
    ) {
      formEl.dropVal = dropVal || null;
      const temp = SingleValidation(formEl);
      formEl.error = temp.error;
      formEl.errorText = temp.errorText;
    }
    if (
      formEl.id == id &&
      formEl.boxType == "multi-select" &&
      boxType == "multi-select"
    ) {
      formEl.dropVal = dropVal || null;
      const temp = MultiValidation(formEl);
      formEl.error = temp.error;
      formEl.errorText = temp.errorText;
    }
    return formEl;
  });
};

const SingleValidation: (formObj: FormObjType) => {
  errorText: string;
  error: boolean;
} = (formObj) => {
  let errorText = "";
  let error = false;
  const singleDropVal =
    formObj.boxType == "single-select" ? formObj.dropVal : null;
  if (formObj.required || singleDropVal) {
    if (!singleDropVal || singleDropVal.toString().length === 0) {
      errorText = "Please select a value";
      error = true;
    }
  }
  return { errorText, error };
};

const MultiValidation: (formObj: FormObjType) => {
  errorText: string;
  error: boolean;
} = (formObj) => {
  let errorText = "";
  let error = false;
  const dropVal = formObj.boxType == "multi-select" ? formObj.dropVal : [];
  if (formObj.required || (dropVal && dropVal?.length > 0)) {
    if (!dropVal || dropVal.length < 1) {
      errorText = "Please select minimum 1 option";
      error = true;
    }
  }
  return { errorText, error };
};

const DateValidation: (formObj: FormObjType) => {
  errorText: string; error: boolean;
} = (formObj) => {
  let errorText = "";
  let error = false;
  if (formObj.boxType == "date" || formObj.boxType == "date-time") {
    const DateVal = DateTime.ValidDate(formObj.inputVal);
    const minValDate = DateTime.ValidDate(formObj.minVal);
    const maxValDate = DateTime.ValidDate(formObj.maxVal);
    const text = "date" + (formObj.boxType == "date-time" ? " time" : "");
    if (!DateVal) {
      errorText = `Please select a ${text}`;
      error = true;
    } else if (
      minValDate && DateTime.CalculateDuration(minValDate, DateVal) < 0
    ) {
      errorText = `Please select a newer ${text}`;
      error = true;
    } else if (
      maxValDate && DateTime.CalculateDuration(DateVal, maxValDate) < 0
    ) {
      errorText = `Please select an older ${text}`;
      error = true;
    }
  }
  return { errorText, error };
};

const HandleParentRoute: (props: ParentRouteProps) => string = (props) => {
  const { prgm, careId, isRec, recId, isRev } = props;
  const baseURL = prgm == "RPM" ? RouteUrls.treatmentPlan : RouteUrls.carePlan;
  if (prgm == "TCM") return `${RouteUrls.tcm}/${careId}`;
  if (isRev) return `${RouteUrls.revisionPlan}/${careId}`;
  else if (isRec) return `${baseURL}/${careId}/${RouteUrls.recurring}/${recId}`;
  else return `${baseURL}/${careId}`;
};

const HandleScreenRoute: (props: FullRouteProps) => string = (props) => {
  const { prgm, careId, isRec, recId, isRev, careState } = props;
  const parentURL = HandleParentRoute({ prgm, careId, isRec, recId, isRev });
  if (prgm == "TCM") {
    if (careId) return `${parentURL}/${HandleStateRoute(careState)}`;
    else return `${RouteUrls.dischargeSummary}`;
  } else if (careId) {
    if (isRec) {
      let lastURL = ""
      if (prgm == "RPM") lastURL = RouteUrls.rpmrecurring;
      else lastURL = RouteUrls.careQuestion;
      return `${parentURL}/${lastURL}`;
    } else return `${parentURL}/${HandleStateRoute(careState)}`;
  } else return `${RouteUrls.program}`;
};

const HandleStateRoute: (cpState: string) => string = (cpState) => {
  switch (cpState) {
    case "Pending problem assignment":
      return RouteUrls.careProblem;
    case "Pending device assignment":
      return RouteUrls.rpmAddDevice;
    case "Pending questionnaire":
      return RouteUrls.careQuestion;
    case "Pending team assignment":
      return RouteUrls.careTeam;
    case "Pending share with provider":
      return RouteUrls.careSummary;
    case "Pending for provider approval":
      return RouteUrls.careSummary;
    default:
      return RouteUrls.careSummary;
  }
};

const MergeNameDesign: (name: string, design: string) => string = (
  name,
  design
) => {
  return name ? name + `${design ? ", " + design : ""}` : "";
};

const HandleNavArr: (navObj: ReduxScreenNavType) => void = (navObj) => {
  const dispatch = store.dispatch;
  let { navArr }: ScreenInitialStateType = store.getState().screen;
  navArr = navArr.filter(
    (el) => el.level < navObj.level && el.navType == navObj.navType
  );
  dispatch(setNavArr([...navArr, navObj]));
};

export default {
  HandleInputChange,
  HandleInputChange2,
  HandleClickChange,
  SingleValidation,
  MultiValidation,
  HandleValidateForm,
  HandleParentRoute,
  MergeNameDesign,
  HandleScreenRoute,
  HandleNavArr,
};
